import React, { useEffect, useState } from "react";
import { MdOutlineSearch } from "react-icons/md";

const AdminSearchBar = ({
  title,
  onAddNewClick,
  onSearchClick,
  hideAddButton = false,
  hideSearchButton = false,
  leftComponent = null,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery.trim());
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    !hideSearchButton && onSearchClick(debouncedQuery);
  }, [debouncedQuery]);

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 py-4 px-4 sm:px-6 bg-gray-100 shadow-md mb-2">
      <h2 className="text-xl font-semibold">{title}</h2>

      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 w-full md:w-auto">
        {/* Left component (like date filter) */}
        {leftComponent && (
          <div className="w-full sm:w-auto">{leftComponent}</div>
        )}

        {/* Search form */}
        {!hideSearchButton && (
          <form
            onSubmit={(e) => e.preventDefault()}
            className="relative flex-1 sm:flex-initial"
          >
            <MdOutlineSearch
              size={20}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
            />
            <input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search..."
              enterKeyHint="search"
              className="pl-10 pr-10 py-2 w-full border border-gray-300 rounded outline-primaryColor placeholder:font-medium"
            />
            {searchQuery.length > 0 && (
              <button
                type="button"
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-red-500 transition-colors duration-150"
                title="Clear"
              >
                ✕
              </button>
            )}
          </form>
        )}

        {!hideAddButton && (
          <button
            type="button"
            onClick={onAddNewClick}
            className="px-4 py-2 bg-primaryColor text-white rounded hover:opacity-90"
          >
            + Add New
          </button>
        )}
      </div>
    </div>
  );
};

export default AdminSearchBar;
